export default __webpack_public_path__ + "static/2-a23c0f78ae0a0a6753e3c4883246b155.png";